/** 只读取站点配置中的网站品牌名，不提供其他默认品牌。 */
export function getSiteBrandName(name?: string | null) {
  return name?.trim() ?? "";
}
